import type { Theme } from '@mui/material'

export const CLICKABLE_ROW_CLASS_NAME = 'clickable-row'

// For plain tables and lists, applied through sx
export const CLICKABLE_ROW_SX = {
  cursor: 'pointer',
  '&:hover': { backgroundColor: 'action.hover' },
  '&:focus-visible': {
    outline: (theme: Theme) => `2px solid ${theme.palette.primary.main}`,
    outlineOffset: -2,
  },
}

// For DataGrid, applied through theme overrides. Only rows marked as
// clickable get the hover background. Themes hide the focus outline of
// cells for mouse users; keyboard users still need to see which row Enter
// will open.
export const getRowClickStyles = (focusColor: string) => ({
  [`& .${CLICKABLE_ROW_CLASS_NAME}`]: {
    cursor: 'pointer',
  },
  [`& .MuiDataGrid-row:not(.${CLICKABLE_ROW_CLASS_NAME}):hover, & .MuiDataGrid-row:not(.${CLICKABLE_ROW_CLASS_NAME}).Mui-hovered`]:
    {
      backgroundColor: 'transparent',
    },
  '& .MuiDataGrid-row:focus-visible, & .MuiDataGrid-row .MuiDataGrid-cell:focus-visible, & .MuiDataGrid-columnHeaders .MuiDataGrid-columnHeader:focus-visible':
    {
      outline: `2px solid ${focusColor}`,
      outlineOffset: -2,
    },
})
